import { SbTabsComponent } from "./sb-tabs/sb-tabs.component";
export { SbTabsComponent } from "./sb-tabs/sb-tabs.component";

import { SbTabsCategoriesComponent } from "./sb-tabs-categories/sb-tabs-categories.component";
export { SbTabsCategoriesComponent } from "./sb-tabs-categories/sb-tabs-categories.component";

import { SbMarqueeBetSenseComponent } from "./sb-marquee-betsense/sb-marquee-betsense";
export { SbMarqueeBetSenseComponent } from "./sb-marquee-betsense/sb-marquee-betsense";

import { SbIconBarComponent } from "./sb-icon-bar/sb-icon-bar.component";
export { SbIconBarComponent } from "./sb-icon-bar/sb-icon-bar.component";

import { BetslipOveraskComponent } from "../features/betslip/components/betslip-overask/betslip-overask.component";
export { BetslipOveraskComponent } from "../features/betslip/components/betslip-overask/betslip-overask.component";

import { SportsPageHeaderComponent } from "./sports-page-header/sports-page-header.component";
export { SportsPageHeaderComponent } from "./sports-page-header/sports-page-header.component";

import { BetbuilderComponent } from "./sb-betbuilder/sb-betbuilder";
export { BetbuilderComponent } from "./sb-betbuilder/sb-betbuilder";

import { SportsKeyboardComponent } from "./sports-keyboard/sports-keyboard.component";
export { SportsKeyboardComponent } from "./sports-keyboard/sports-keyboard.component";

import { SbDropdownMenuComponent } from "./sb-dropdown-menu/sb-dropdown-menu.component";
export { SbDropdownMenuComponent } from "./sb-dropdown-menu/sb-dropdown-menu.component";

import { SbButtonComponent } from "./sb-button/sb-button";
export { SbButtonComponent } from "./sb-button/sb-button";

import { SbHeaderWithCounterComponent } from "./sb-header-with-counter/sb-header-with-counter.component";
export { SbHeaderWithCounterComponent } from "./sb-header-with-counter/sb-header-with-counter.component";

import { SbCounterComponent } from "./sb-counter/sb-counter.component";
export { SbCounterComponent } from "./sb-counter/sb-counter.component";

import { SbSportIconComponent } from "./sb-sport-icon/sb-sport-icon.component";
export { SbSportIconComponent } from "./sb-sport-icon/sb-sport-icon.component";

import { CodereGridFilterComponent } from "./codere-grid-filter/codere-grid-filter.component";
export { CodereGridFilterComponent } from "./codere-grid-filter/codere-grid-filter.component";

import { CodereSidebarPcComponent } from "../features/proxy/components/codere-sidebar-pc/codere-sidebar-pc";
export { CodereSidebarPcComponent } from "../features/proxy/components/codere-sidebar-pc/codere-sidebar-pc";

import { CodereStyleMoneyComponent } from "./codere-style-money/codere-style-money";
export { CodereStyleMoneyComponent } from "./codere-style-money/codere-style-money";

import { SbGridContentExpandedComponent } from "./sb-grid-content-expanded/sb-grid-content-expanded";
export { SbGridContentExpandedComponent } from "./sb-grid-content-expanded/sb-grid-content-expanded";

import { SbGridContentSingleComponent } from "./sb-grid-content-single/sb-grid-content-single";
export { SbGridContentSingleComponent } from "./sb-grid-content-single/sb-grid-content-single";

import { SbGridContentTeamsComponent } from "./sb-grid-content-teams/sb-grid-content-teams";
export { SbGridContentTeamsComponent } from "./sb-grid-content-teams/sb-grid-content-teams";

import { SbGridContentThumbnailComponent } from "./sb-grid-content-thumbnail/sb-grid-content-thumbnail";
export { SbGridContentThumbnailComponent } from "./sb-grid-content-thumbnail/sb-grid-content-thumbnail";

import { SbGridHeaderComponent } from "./sb-grid-header/sb-grid-header";
export { SbGridHeaderComponent } from "./sb-grid-header/sb-grid-header";

import { SbGridItemComponent } from "./sb-grid-item/sb-grid-item";
export { SbGridItemComponent } from "./sb-grid-item/sb-grid-item";

import { SbOverviewScoreSetsComponent } from "./sb-overview-score-sets/sb-overview-score-sets";
export { SbOverviewScoreSetsComponent } from "./sb-overview-score-sets/sb-overview-score-sets";

import { SportradarWidgetComponent } from "../features/proxy/components/sportradar-widget/sportradar-widget";
export { SportradarWidgetComponent } from "../features/proxy/components/sportradar-widget/sportradar-widget";

import { SbOverviewScoreRegularComponent } from "./sb-overview-score-regular/sb-overview-score-regular";
export { SbOverviewScoreRegularComponent } from "./sb-overview-score-regular/sb-overview-score-regular";

import { SbPrematchItemComponent } from "./sb-prematch-item/sb-prematch-item";
export { SbPrematchItemComponent } from "./sb-prematch-item/sb-prematch-item";

import { SbGridFilterComponent } from "./sb-grid-filter/sb-grid-filter";
export { SbGridFilterComponent } from "./sb-grid-filter/sb-grid-filter";

import { SbLiveScoreboardSetsComponent } from "./sb-live-scoreboard-sets/sb-live-scoreboard-sets";
export { SbLiveScoreboardSetsComponent } from "./sb-live-scoreboard-sets/sb-live-scoreboard-sets";

import { SbLiveScoreboardRegularComponent } from "./sb-live-scoreboard-regular/sb-live-scoreboard-regular";
export { SbLiveScoreboardRegularComponent } from "./sb-live-scoreboard-regular/sb-live-scoreboard-regular";

import { SbLiveScoreboardBaseballComponent } from "./sb-live-scoreboard-baseball/sb-live-scoreboard-baseball";
export { SbLiveScoreboardBaseballComponent } from "./sb-live-scoreboard-baseball/sb-live-scoreboard-baseball";

import { SbDropdownComponent } from "./sb-dropdown/sb-dropdown";
export { SbDropdownComponent } from "./sb-dropdown/sb-dropdown";

import { SbPrematchScoreboardComponent } from "./sb-prematch-scoreboard/sb-prematch-scoreboard";
export { SbPrematchScoreboardComponent } from "./sb-prematch-scoreboard/sb-prematch-scoreboard";

import { SbLiveNavbarComponent } from "./sb-live-navbar/sb-live-navbar";
export { SbLiveNavbarComponent } from "./sb-live-navbar/sb-live-navbar";

import { MyBetTicketComponent } from "../features/my-bets/components/my-bet-ticket/my-bet-ticket";
export { MyBetTicketComponent } from "../features/my-bets/components/my-bet-ticket/my-bet-ticket";

import { SbSimpleNavbarComponent } from "./sb-simple-navbar/sb-simple-navbar";
export { SbSimpleNavbarComponent } from "./sb-simple-navbar/sb-simple-navbar";

import { SportsBetButtonComponent } from "./sports-button/sports-bet-button";
export { SportsBetButtonComponent } from "./sports-button/sports-bet-button";

import { SportsGridContentSingleComponent } from "./sports-grid/sports-grid-contents/sports-grid-content-single/sports-grid-content-single";
export { SportsGridContentSingleComponent } from "./sports-grid/sports-grid-contents/sports-grid-content-single/sports-grid-content-single";

import { SportsGridContentTeamsComponent } from "./sports-grid/sports-grid-contents/sports-grid-content-teams/sports-grid-content-teams";
export { SportsGridContentTeamsComponent } from "./sports-grid/sports-grid-contents/sports-grid-content-teams/sports-grid-content-teams";

import { SportsBetButtonWrapperColumnComponent } from "./sports-bet-button-wrapper-column/sports-bet-button-wrapper-column.component";
export { SportsBetButtonWrapperColumnComponent } from "./sports-bet-button-wrapper-column/sports-bet-button-wrapper-column.component";

import { SportsGridComponent } from "./sports-grid/sports-grid";
export { SportsGridComponent } from "./sports-grid/sports-grid";

import { SportsGridHelperComponent } from "./sports-grid/sports-grid-helper/sports-grid-helper.component";
export { SportsGridHelperComponent } from "./sports-grid/sports-grid-helper/sports-grid-helper.component";

import { SportsGroupComponent } from "./sports-group/sports-group.component";
export { SportsGroupComponent } from "./sports-group/sports-group.component";

import { SportsLiveNavbarComponent } from "./sports-live-navbar/sports-live-navbar";
export { SportsLiveNavbarComponent } from "./sports-live-navbar/sports-live-navbar";

import { FreeBetsHeader } from "../features/free-bets/components/free-bets-header/free-bets-header-component";
export { FreeBetsHeader } from "../features/free-bets/components/free-bets-header/free-bets-header-component";

import { FreeBetsInfo } from "../features/free-bets/components/free-bets-info/free-bets-info.component";
export { FreeBetsInfo } from "../features/free-bets/components/free-bets-info/free-bets-info.component";

import { FreeBetsVerification } from "../features/free-bets/components/free-bets-verification/free-bets-verification-component";
export { FreeBetsVerification } from "../features/free-bets/components/free-bets-verification/free-bets-verification-component";

export const Components: any[] = [
  BetslipOveraskComponent,
  SbTabsComponent,
  SbMarqueeBetSenseComponent,
  SbIconBarComponent,
  SbMarqueeBetSenseComponent,
  SbTabsCategoriesComponent,
  SbTabsComponent,
  SportsPageHeaderComponent,
  BetbuilderComponent,
  SportsKeyboardComponent,
  SbDropdownMenuComponent,
  SbButtonComponent,
  SbHeaderWithCounterComponent,
  SbCounterComponent,
  SbSportIconComponent,
  CodereGridFilterComponent,
  CodereSidebarPcComponent,
  CodereStyleMoneyComponent,
  SbGridContentExpandedComponent,
  SbGridContentSingleComponent,
  SbGridContentTeamsComponent,
  SbGridContentThumbnailComponent,
  SbGridHeaderComponent,
  SbGridItemComponent,
  SbOverviewScoreSetsComponent,
  SportradarWidgetComponent,
  SbOverviewScoreRegularComponent,
  SbPrematchItemComponent,
  SbGridFilterComponent,
  SbLiveScoreboardSetsComponent,
  SbLiveScoreboardRegularComponent,
  SbLiveScoreboardBaseballComponent,
  SbDropdownComponent,
  SbPrematchScoreboardComponent,
  SbLiveNavbarComponent,
  MyBetTicketComponent,
  SbSimpleNavbarComponent,

  SportsBetButtonComponent,
  SportsBetButtonWrapperColumnComponent,
  SportsGridContentSingleComponent,
  SportsGridContentTeamsComponent,
  SportsGridComponent,
  SportsGridHelperComponent,
  SportsGroupComponent,
  SportsLiveNavbarComponent,

  FreeBetsHeader,
  FreeBetsVerification,
  FreeBetsInfo,
];
